// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2J6VO","list":"styles_list__20lbi"};